import { Dispatch, SetStateAction } from "react";

import dweLogo from "../../assets/images/webLogin/dweLogo.svg";
import useStore from "../../hooks/store/useStore";
import { MenuItemType } from "../../types";
import BookButton from "../bookDemo/BookButton";
import AppDownloadModel from "../listen/components/AppDownloadModel";
import DisneyMenuBubbles from "./DisneyMenuBubbles";

export default function DisneyMenuWeb({
  setSelectedMenuItem,
  setShowDisneyMenu,
}: {
  setSelectedMenuItem: Dispatch<SetStateAction<MenuItemType>>;
  setShowDisneyMenu: Dispatch<SetStateAction<boolean | null>>;
}) {
  const { showAppDownloadModel } = useStore((state) => state.webVersion);

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-start bg-gradient-to-b from-white to-pink1 pb-[52px]">
      <img
        src={dweLogo}
        alt="dweLogo"
        className="mb-6 mt-4 w-[162px] tablet-lg:mb-[72px] tablet-lg:mt-8 tablet-lg:w-[240px]"
      />

      <div className="[@media(min-height:800px)]:my-auto">
        <DisneyMenuBubbles
          setSelectedMenuItem={setSelectedMenuItem}
          setShowDisneyMenu={setShowDisneyMenu}
          isWeb
        />
      </div>

      {showAppDownloadModel ? (
        <AppDownloadModel eventId="World Family Club" />
      ) : null}

      <BookButton sourcePage="Disney Menu" />
    </div>
  );
}
